export function isDocumentUnassigned(projectId?: string | null): boolean {
  return !String(projectId || '').trim();
}

export function assertCanAssignDocumentToProject(
  currentProjectId: string | null | undefined,
  nextProjectId: string | null | undefined
): void {
  const current = String(currentProjectId || '').trim();
  const next = String(nextProjectId || '').trim();
  if (!next || !current || current === next) return;
  throw new Error('This document is already linked to another workspace.');
}
